import Fees from './Fees.container';

export default Fees;
